import styled, { keyframes } from 'styled-components'

import { PLACE_TO_RENDER } from '../../constants'

export const Form = styled.form<{ $renderPlace: string }>`
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
  gap: 3rem;
  padding: 3rem;
  border-radius: 10px;
  background: ${({ $renderPlace }) =>
    $renderPlace === PLACE_TO_RENDER.FORM ? '#ebeffe' : 'white'};

  @media (max-width: 767px) {
    padding: ${({ $renderPlace }) =>
      $renderPlace === PLACE_TO_RENDER.FORM ? '1rem 1rem 2rem 1rem' : '1rem'};
  }
`

export const Block = styled.div<{ $renderPlace: string }>`
  display: grid;
  grid-template-columns: ${({ $renderPlace }) =>
    $renderPlace === PLACE_TO_RENDER.FORM ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'};
  gap: 1.5rem;

  > *:nth-child(3),
  > *:nth-child(4),
  > *:nth-child(5) {
    grid-column: ${({ $renderPlace }) =>
      $renderPlace === PLACE_TO_RENDER.FORM ? 'span 2' : 'span 1'};
  }

  @media (max-width: 999px) {
    grid-template-columns: repeat(1, 1fr);

    > *:nth-child(3),
    > *:nth-child(4),
    > *:nth-child(5) {
      grid-column: span 1;
    }
  }
`

export const LabelWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  color: #292e3d;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
`

export const Select = styled.div`
  width: 100%;
  height: fit-content;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5rem;
`

export const Button = styled.button`
  width: 100%;
  height: 5rem;
  padding: 0 2rem 0 2rem;
  border-radius: 20px;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  line-height: 2rem;
  color: #fbf6fe;
  font-weight: 400;
  border-radius: 5px;
  background: #3a64f8;

  &:hover {
    color: '#6B8BFA';
    transition: all 0.2s ease-out;
  }
`

const ButtonSuccessAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const ButtonSuccess = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  padding: 13px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #c1f6e4;
  color: #17a073;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  animation: ${ButtonSuccessAnimation} 0.2s ease-out;
`

export const Text = styled.p`
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  line-height: 2rem;
  color: #292e3d;
  font-weight: 400;
`

export const Error = styled.p`
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: #fa3848;
  font-weight: 400;
`

export const CaptchaWrapper = styled.div`
  position: absolute;
  bottom: 0;
`
